import { Components } from "appworks/components/components";
import { PromptComponent } from "appworks/components/prompt/prompt-component";
import { PromptContent } from "appworks/components/prompt/prompt-content";
import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { State } from "appworks/state-machine/states/state";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { deviceInfo } from "appworks/utils/device-info";

export class TGRRetriggerFreespins extends State {

    public onEnter() {
        uiFlags.set(UIFlag.PROMPT, true);

        this.showPrompt();
    }

    public complete() {
        uiFlags.set(UIFlag.PROMPT, false);
        uiFlags.set(UIFlag.FREE_SPINS, true);

        super.complete();
    }

    protected showPrompt(prompt?: PromptContent) {
        prompt = new PromptContent(["freespinswin"], Infinity);
        const record = gameState.getCurrentGame().getCurrentRecord();

        prompt.setText("value", `+ ${record.getFreespinsWon().toString()}`);
        prompt.setText("click_tap_play", Services.translations.get(`${deviceInfo.isDesktop ? "clk" : "tap" }.ply`));
        prompt.setClickToSkip(true);

        Components.get(PromptComponent).showPrompt(prompt).then(() => this.complete());
    }
}
